export const replaceHyperlinks = (str: string) => {
  const parts = str.split(/(https?:\/\/[^\s]+)/g);
  return parts.map((part, i) =>
    part.startsWith("http") ? (
      <a key={i} href={part} className="underline font-medium" target="_blank">
        {part}
      </a>
    ) : (
      part
    ),
  );
};
